<template>
  <v-tooltip
    v-bind="$attrs"
    :activator="$parent"
    allow-overflow
    :bottom="location === 'bottom'"
    close-delay="100"
    content-class="chart-resume-tooltip"
    :left="location === 'left'"
    min-width="auto"
    :nudge-bottom="location === 'top' ? 12 : 0"
    :nudge-left="location === 'right' ? 12 : 0"
    :nudge-right="location === 'left' ? 12 : 0"
    :nudge-top="location === 'bottom' ? 12 : 0"
    opacity="1"
    :open-delay="100"
    origin="center center"
    :right="location === 'right'"
    :top="location === 'top'"
    transition="fade-transition"
    :value="visible"
    @input="$emit('updateVisibility', $event)"
  >
    <div
      ref="resume"
      :class="[`repartition-bar-item-resume__${location}`, {'repartition-bar-item-resume__with-arrow': !$vuetify.breakpoint.mobile || location === 'left' || location === 'right'}]"
      class="repartition-bar-item-resume align-self-center"
    >
      <GraphLegendLabel :label="item.label" />

      <div class="d-flex align-center">
        <GraphDataValue
          :value="item.value"
          :unit="unit"
          :positive-color="positiveColor"
          :negative-color="negativeColor"
          class="mr-2"
        />
        <GraphLegendPercentage
          :value="item.percentage"
          :color="item.color"
        />
      </div>
    </div>
  </v-tooltip>
</template>

<script>
import GraphDataValue from './graph-data-value.vue'
import GraphLegendLabel from './graph-legend-label.vue'
import GraphLegendPercentage from './graph-legend-percentage.vue'

export default {
  name: 'RepartitionBarItemResume',

  components: {
    GraphDataValue,
    GraphLegendLabel,
    GraphLegendPercentage
  },

  props: {
    visible: {
      type: Boolean,
      default: true
    },
    item: {
      type: Object,
      required: true
    },
    unit: {
      type: String,
      default: null
    },
    positiveColor: {
      type: String,
      default: 'success'
    },
    negativeColor: {
      type: String,
      default: 'warning'
    },
    location: {
      type: String,
      required: true
    }
  },
  
  emits: ['updateVisibility'],

  data () {
    return {
      nudge: 12
    }
  }
}
</script>

<style lang="scss" scoped>
.repartition-bar-item-resume {
  position: relative;
  padding: 16px;
  margin: 14px;
  border-radius: 12px;
  background-color: #ffffff;
  filter: drop-shadow(
      0px 3px 1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2))
    )
    drop-shadow(
      0px 2px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14))
    )
    drop-shadow(
      0px 1px 3px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12))
    );

   &.repartition-bar-item-resume__with-arrow {
    &.repartition-bar-item-resume__bottom {
      &::after {
        top: -5px;
        left: calc(50% - 10px);
        right: 0;
      }
    }

    &.repartition-bar-item-resume__top {
      &::after {
        bottom: -5px;
        left: calc(50% - 10px);
        right: 0;
      }
    }

    &.repartition-bar-item-resume__left {
      &::after {
        bottom: 0;
        top: calc(50% - 10px);
        right: -5px;
      }
    }

    &.repartition-bar-item-resume__right {
      &::after {
        bottom: 0;
        top: calc(50% - 10px);
        left: -5px;
      }
    }

    &::after {
      content: '';
      position: absolute;
      z-index: -10;
      width: 20px;
      height: 20px;
      transform: rotate(45deg);
      background-color: #ffffff;
    }
  }
}
</style>
